import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import {
  MOBILE_PRO_CHROME_TITLE_CLASS,
  MOBILE_PRO_CHROME_TOP_ROW_CLASS,
  MOBILE_PRO_CHROME_TRAILING_CLASS,
} from "./mobile-pro-chrome";

export interface MobileProTopBarProps {
  title: string;
  trailing?: ReactNode;
  className?: string;
}

function MobileProTopBar({ title, trailing, className }: MobileProTopBarProps) {
  return (
    <header className={cn(MOBILE_PRO_CHROME_TOP_ROW_CLASS, className)}>
      <h1 className={cn(MOBILE_PRO_CHROME_TITLE_CLASS, "min-w-0 flex-1")}>{title}</h1>
      {trailing ? <div className={MOBILE_PRO_CHROME_TRAILING_CLASS}>{trailing}</div> : null}
    </header>
  );
}

export { MobileProTopBar };
